import React from 'react'
import classes from './ProfileCard.module.css'
import NotAvailable from '../NotAvailable'
import { Urls } from '../../../Urls'

const ProfileCard = ({profile}) => {
    const ExpressInterest=(status)=>{
        if(!status){
            //API Call
        }
    }

    return (
        <div className={classes['Container']}>
            {
                profile?
                <div className={classes['Body']}>
                <div className={`${classes['LeftCol']}`}>
                    <div className={classes['companyProfileLogodiv']} >
                        <img alt='img' className={classes['companyProfileLogo']} src={Urls.LorriLogoLogin} />
                    </div>
                    <div className={classes['ActionsDiv']}>
                        <button type="button" className={`btn btn-outline-primary ${classes['WebsiteButton']}`}><a href={profile.website} target="_blank" rel="noreferrer noopener">Website</a></button>
                        <button type="button" onClick={e=>ExpressInterest(profile.expressed_interest)} className={`${profile.expressed_interest?'btn btn-success':'btn btn-outline-primary'} ${classes['Expressbutton']}`}>
                            {
                                profile.expressed_interest?'Expressed Interest':'Express Interest'
                            }
                            </button>
                    </div>
                    </div>
               
                <div className={classes['RightCol']}>
                {
                profile.company_name?
                <div className={`${classes['displayFlex']} ${classes['flex-direction-row']} ${classes['Company']}`}>
                    {profile.company_name}
                </div>
                :null
                }
                {
                profile.company_type?
                <div className={`${classes['displayFlex']} ${classes['flex-direction-row']} ${classes['Type']}`}>
                    {profile.company_type}
                </div>
                :null
                }
                {
                profile.hq_address?
                <div className={`${classes['displayFlex']} ${classes['flex-direction-column']} ${classes['Hq']}`}>
                    <label className={classes['LabelName']}>HeadQuarter</label>
                    {profile.hq_address}
                </div>
                :null
                }
                {
                profile.established?
                <div className={`${classes['displayFlex']} ${classes['flex-direction-row']} ${classes['Est']}`}>
                   <label className={classes['LabelName']}>Established : {profile.established}</label>
                </div>
                :null
                }
                {
                profile.industries?
                <div className={`${classes['displayFlex']} ${classes['flex-direction-column']} ${classes['Industries']}`}>
                    <label className={classes['LabelName']}>
                        Industries
                    </label>
                    <div className={`${classes['displayFlex']} ${classes['flex-direction-column']} ${classes['Categories']}`}>
        
                    {profile.industries.map(item=><span>{item.name}</span>)}
                    </div>
                </div>
                :null
                }
                {
                profile.product_categories?
                <div className={`${classes['displayFlex']} ${classes['flex-direction-column']} ${classes['Categories']}`}>
                    <label className={classes['LabelName']}>
                        Categories
                    </label>
                    <div className={`${classes['displayFlex']} ${classes['flex-direction-column']} ${classes['Categories']}`}>
                {profile.product_categories.map(item=><span>{item.name}</span>)}
                    </div>
                </div>
                :null
                }
                </div>
                
            </div>
                
                :
                <NotAvailable/>
            }
           
        </div>
    )
}



export default ProfileCard
